<div class="py-5 px-3">
  <h1 mat-dialog-title *ngIf="message && isArray(message)">
    {{ statusText || "Error Message" }}
    <span class="material-symbols-outlined icon-error red_text"> error </span>
  </h1>
  <div *ngIf="message && isArray(message)">
    <ul class="ps-3">
      <li *ngFor="let error of message">
        {{ error }}
      </li>
    </ul>
  </div>
  <div *ngIf="message && isString(message)">
    <h1 mat-dialog-title>
      {{ message }}
      <span class="icon-error primary-text">
        <svg
          class="w-6 h-6 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </span>
    </h1>
  </div>
  <div mat-dialog-actions class="mt-4 ws-100">
    <button
      (click)="onCancel()"
      mat-raised-button
      color="primary"
      class="w-100"
      cdkFocusInitial
    >
      Close
    </button>
  </div>
</div>
